<template>
  <div :class="$style.container">
    <div :class="$style.breadcrumb_container">
      <div class="main-width">
        <VBreadcrumb :class="$style.breadcrumb" theme="white" :options="breadcrumbs"/>
      </div>
    </div>
    <div class="relative">
      <img class="w-full" src="~@/assets/img/product/vacation-list-banner.png" alt="banner"/>
    </div>
    <div class="main-width" :class="$style.main">
      <div :class="$style.search_container">
        <list-filter :loading="isLoadingFilterData" :filter-data="filterData" v-bind.sync="searchData"
                     @on-filter-change="onFilterChange"/>
      </div>


      <!-- <ResourceSearchHead /> -->
      <div :class="$style.result">
        <div :class="$style.result_heading">
          <h3 :class="$style.result_heading_title">为您匹配出<span class="text-highlight mx-1">{{
              pagination.total_count
            }}</span>条产品</h3>
          <div :class="$style.result_heading_sort">
            <sort-bar :sort-name="searchData.sort_name" :sort-type="searchData.sort_type"
                      @on-sort-change="onSortChange"/>
          </div>
        </div>

        <div :class="$style.result_main">
          <div :class="$style.result_content">
            <list-product-skeleton :loading="productLoading">
              <template v-if="productData.list.length">
                <product-item v-for="product in productData.list" :key="product.id" is-top :data="product"
                              @share="onShare(product)" @collect="onCollect(product)" @join="onJoinShop(product)"/>
              </template>
              <no-result v-else>
                <template #title>目前没有满足所有筛选项的产品，请尝试放大筛选范围</template>
              </no-result>
            </list-product-skeleton>


            <div :class="$style.pager_wrap" v-if="productData.list && productData.list.length">
              <div :class="$style.pager_total">共{{ productData.total_count }}条</div>
              <v-pagination :class="$style.pager" :total="productData.total_count"
                            :page="productData.page_index" :pageSize="productData.page_size" prevText="上一页"
                            nextText="下一页" @current-change="onPageChange"/>
            </div>
          </div>
          <div :class="$style.result_aside">
            <PlatformAdvertStairSwiper :items="adStore.banner"/>

            <PlatformAdvertStair v-for="(rec, index) in adStore.recommend" :key="index" :background_color="rec.background_color" :title="rec.name"
                                 :icon-url="rec.icon" :items="rec.products"/>
          </div>
        </div>
      </div>
    </div>

    <ShareShopProduct ref="shareProductRef"/>

    <AppDock />
  </div>
</template>

<script>
/** components */
// import SearchHeader from "@/views/product/components/SearchHeader.vue";
import ListFilter from "@/views/product/VacationListFilter.vue";
import ListProductSkeleton from "@/views/product/ListProductSkeleton.vue";
import ListHotProduct from "@/views/product/ListHotProduct.vue";
import NoResult from "@/views/product/components/ListNoResult";
import SortBar from "@/views/product/ListProductSortBar.vue";
import ProductItem from "@/components/product/list-product-item-vacation.vue";
import ResourceSearchHead from "@/views/product/components/ResourceSearchHead.vue";
import ResourceBannerSwiper from "@/views/product/ResourceBannerSwiper.vue";
import VBreadcrumb from '@/components/VBreadcrumb.vue'
import VPagination from '~/components/VPagination/index.vue'

import SearchInput from "~/components/product/search-input.vue";
import PlatformAdvertStair from '~/components/product/PlatformAdvertStair.vue'
import PlatformAdvertStairSwiper from "~/components/product/PlatformAdvertStairSwiper.vue"

import ShareShopProduct from "@/views/product/components/ShareShopProduct/index.vue";
import AppDock from '~/components/layouts/AppDock.vue'


/** api */
import * as VacationService from "@/services/vacation";


// helpers
import {pick} from "@/utils/helpers";

import {
  ref,
  computed,
  defineComponent,
  reactive,
  useStore,
  watchEffect,
  useFetch, useRoute, useRouter, watch, nextTick
} from "@nuxtjs/composition-api";

import usePagination from "@/composables/usePagination";
import useProductFavorite from '~/views/product/composables/useProductFavorite';
import useProductJoinShop from '~/views/product/composables/useProductJoinShop'
import useRequest from '~/composables/useRequest';

import usePlatformAdvertStairStore from '~/composables/usePlatformAdvertStairStore'


function transformRange(values = []) {
  return values
      .map((value) => value.split("-"))
      .map(([gte, lte]) => ({gte, lte}));
}

function createSearchData() {
  return {
    name: "",
    holidays: [],
    months: [],
    days_range: [],
    city: [],
    price_range: [],
    product_type: [],
    sort_type: "",
    sort_name: ""
  };
}

export default defineComponent({
  name: "VacationList",
  head: {
    title: "度假产品"
  },
  auth: false,
  layout: "Main",
  components: {
    AppDock,
    // SearchHeader,
    VBreadcrumb,
    SearchInput,
    ListFilter,
    ListProductSkeleton,
    ListHotProduct,
    NoResult,
    SortBar,
    ResourceSearchHead,
    ResourceBannerSwiper,
    ProductItem,
    PlatformAdvertStair,
    PlatformAdvertStairSwiper,
    VPagination,

    ShareShopProduct

  },

  setup(props) {

    const breadcrumbs = [
      {label: '首页', to: '/'},
      {label: '度假产品列表'}
    ]

    const route = useRoute();
    const searchData = reactive(createSearchData());
    const searchKeywords = computed(() => {
      let {keywords = ""} = route.value.query;
      return keywords;
    });

    const {
      state: productData,
      pagination,
      isLoading: productLoading,
      onPageChange,
      onSearch: search,
      execute
    } = usePagination(
        ({page_index, page_size}) =>
            VacationService.getProductList({
              name: searchKeywords.value,
              ...searchData,
              days_range: transformRange(searchData.days_range),
              price_range: transformRange(searchData.price_range).map(
                  ({gte: gt, lte}) => ({gt, lte})
              ),
              page_index,
              page_size
            }),
        {
          list: []
        },
        {
          immediate: false
        }
    );

    const {
      isLoading: isLoadingFilterData,
      state: filterData,
      execute: fetchFilterData
    } = useRequest(VacationService.getProductFilter, {
      date: [],
      days: [],
      price: [],
      city: [],
      holiday: []
    }, {
      immediate: false
    })


    useFetch(async () => {
      await syncRouteQuery(route.value.query);
      await Promise.all([fetchFilterData(), execute()])
    });
    const syncRouteQuery = async (query) => {
      Object.assign(searchData, pick(query, Object.keys(searchData)));
      await nextTick();
    }
    const router = useRouter();

    function onSearch() {
      router.replace({
        // path: "",
        query: {
          ...searchData
        }
      });
    }

    watch(
        () => route.value.query,
        async (query) => {
          const {keywords = ""} = query;
          if (keywords && keywords !== searchData.name) {
            searchData.name = keywords;
          }
          await syncRouteQuery(query)
          // Object.assign(searchData, pick(query, Object.keys(searchData)));
          //
          search();
        }
    );


    function onFilterChange() {
      onSearch();
    }

    function onSortChange(sortParams = {}) {
      Object.assign(searchData, sortParams);
      onSearch();
    }

    // onMounted(() => {
    //   fetchProductList(0, pagination);
    // });
    const store = useStore();


    // ======================= 分享 =======================
    const shareProductRef = ref();
    const onShare = (product) => {
      shareProductRef.value.handleShareShopPrdouct(product);
    }

    // ======================= 收藏 =======================
    // const shareProductRef = ref();
    const {toggleFavorite} = useProductFavorite();
    const onCollect = async (product) => {
      await toggleFavorite(!!product.is_favorite, product.product_no)
      await execute();

    }

    const {
      joinShop
    } = useProductJoinShop();

    async function onJoinShop(product) {
      await joinShop(product.product_no)
      await execute();
    }


    // ======================= 推荐位 =======================
    const adStore = usePlatformAdvertStairStore('vacation_search_right');


    return {
      breadcrumbs,
      isLoadingFilterData,
      filterData,

      searchData,
      productData,
      pagination,
      productLoading,
      onSearch,

      onPageChange,
      onFilterChange,
      onSortChange,
      loggedIn: computed(() => {
        return store.getters.loggedIn;
      }),

      shareProductRef,
      onShare,


      onCollect,

      onJoinShop,


      adStore
    };
  },
  data() {
    return {
      searchLoading: false,

      noSearch: false,

      // productLoading: false,
      // productData: {
      //   list: []
      // },
      recommend: []
    };
  }
});
</script>


<style lang="scss" module>
.pager_total {
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.container {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  padding-bottom: 2.5rem;
  position: relative;
}
.breadcrumb {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.breadcrumb_container {
  position: absolute;
  top: 0px;
  width: 100%;
  z-index: 1;
}
.main {
  margin-top: -7rem;
  position: relative;
}
.search_container {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 0.25rem;
  padding-left: 1.75rem;
  padding-right: 1.75rem;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
}
.result_heading {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.result_heading_title {
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.result_heading_sort {
  font-size: 1rem;
  line-height: 1.5rem;
  margin-left: auto;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.result_main {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}
.result_content {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
}
.result_aside {
  margin-left: 1.25rem;
  width: 15.625rem;
}
.pager_wrap {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 0.25rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  margin-top: 1.25rem;
  padding-left: 1.75rem;
  padding-right: 1.75rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
}
</style>
